"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UndecidedEventFilter = void 0;
class UndecidedEventFilter {
    static filter({ events, isUndecidedEventBookable }) {
        if (isUndecidedEventBookable) {
            return events.filter((ev) => ev.responseStatus === 'accepted');
        }
        return events.filter((ev) => ['accepted', 'needsAction', 'tentative'].includes(ev.responseStatus));
    }
}
exports.UndecidedEventFilter = UndecidedEventFilter;
//# sourceMappingURL=undecidedEventFilter.js.map